/** DSV MVC siteSelector in header
 *
 */
(function ($, window) {
    "use strict";
    DSV.ui.headerWidget = {
        toggleHeaderWidget(container) {
            for (let i = 0; i < container.length; i++) {
                const widget = container[i];
                const widgetTrigger = widget.querySelector('.header-widget__button');
                const widgetOverlay = widget.querySelector('.header-widget__overlay');
                const widgetClose = widget.querySelector('.header-widget__close');
                const widgetOverlayActiveClass = "header-widget--active";
                let isMobile = DSV.tools.screenMode.currentMode < (DSV.tools.screenSizes.large + 1);


                setWidget();
            
                widgetTrigger.addEventListener('click', (event) => {
                    event.preventDefault();
                    toggleWidget();
                });
            
                widgetClose.addEventListener('click', (event) => {
                    event.preventDefault();
                    toggleWidget();
                });            
            
                window.addEventListener('scroll', this.throttle(300, setWidget));
                window.addEventListener('scroll', this.debounce(300, setWidget));  
                
                window.addEventListener('resize', () => {
                    isMobile = DSV.tools.screenMode.currentMode < (DSV.tools.screenSizes.large + 1);
                    this.debounce(300, setWidget());
                });
                
                function setWidget() {
                    widgetOverlay.classList.remove(widgetOverlayActiveClass);

                    if (isMobile && widget.classList.contains('header-widget--search')) {
                        //If is search widget
                        TweenLite.set(widgetOverlay, {clearProps: "all"});
                    } else {
                        //Other widgets than search widget
                        TweenLite.set(widgetOverlay, {x: "100%", "z-index": 10});
                    }
                }
            
                function toggleWidget() {            
                    if (!widgetOverlay.classList.contains(widgetOverlayActiveClass)) {
                        closePreviousWidgets();
                        widgetOverlay.classList.add(widgetOverlayActiveClass);

                        //set focus on search input if present
                        const focusableEls = widgetOverlay.querySelectorAll('input[type="text"]:not([disabled])'),
                            firstFocusableEl = focusableEls[0];

                        if(firstFocusableEl) {
                            firstFocusableEl.focus();
                        }

                        TweenLite.to(widgetOverlay, 0.4, {x: "0%"});
                    } else {
                        widgetOverlay.classList.remove(widgetOverlayActiveClass);
                        TweenLite.to(widgetOverlay, 0.4, {x: "100%"});
                    }                    
                }

                function closePreviousWidgets() {
                    const widgetOverlayActive = document.querySelector(`.${widgetOverlayActiveClass}`);
                    if (widgetOverlayActive) {
                        widgetOverlayActive.classList.remove('header-widget--active');
                        TweenLite.to(widgetOverlayActive, 0.4, {x: "100%"});
                    }
                }
            }   
        },

        handleHeaderWidgetSearch() {
            const searchForm = document.querySelector('.header-widget__form');
            if (!searchForm) return;
            const actionUrl = searchForm.action;
            const searchInput = document.querySelector('.header-widget__input');

            searchForm.addEventListener('submit', e => {
                e.preventDefault();

                let trackNumber = false;
                const searchWord = searchInput.value;

                if(searchWord && searchWord != "") {
                    trackNumber = DSV.ui.checkForTrackNumber(searchWord);
                }

                if (trackNumber && DSV.data.overlayEndpoint) {
                    DSV.ui.overlays.loadContent(`${DSV.data.overlayEndpoint}?id=${trackNumber}`)
                } else {
                    window.location.replace(`${actionUrl}?q=${encodeURIComponent(searchInput.value)}`);
                }
            });
        },
        
        throttle(delay, fn) {
            let lastCall = 0;
            return function(...args) {
                const now = (new Date).getTime();
                if (now - lastCall < delay) {
                    return;
                }
                lastCall = now;
                return fn(...args)
            }
        },
        
        // Check last scroll event
        debounce(delay, fn) {
            let timerId;
            return function(...args) {
                if (timerId) {
                    clearTimeout(timerId);
                }
                timerId = setTimeout(() => {
                    fn(...args);
                    timerId = null;
                }, delay)
            }
        },

        init: function (container) {
            this.toggleHeaderWidget(container);
            this.handleHeaderWidgetSearch(); 
        }
    };
})(jQuery, window);